import {doResultListUpdate} from './_doResultListUpdate';

export var updateOrderByBind = function() {
    $('#orderBy-select').find('.facet-title').on("click touchend", function(e) {
  		e.stopPropagation();
  		var thisOrder = $(this);
		var modifiedSesPz = false;
		if($(this).data("value") == "1" && ((!thisOrder.hasClass("just-for-you-sort") && $(".just-for-you-sort").find("i").length > 0) || (thisOrder.hasClass("just-for-you-sort") && $(".just-for-you-sort").find("i").length == 0))){
			if(thisOrder.hasClass("just-for-you-sort")){
				sessionStorage.setItem("sesPz" + window.superCat, sessionStorage.getItem("oldSesPz" + window.superCat));
			}else{
				sessionStorage.setItem("sesPz" + window.superCat, "");
			}
			modifiedSesPz = true;
		}
		if ($(this).data("value") != $("#orderBy").val() || modifiedSesPz) {
			$("#orderBy").val($(this).data("value"));
			Dillards.doResultListUpdate(false, true);
		} else {
//			$('.sort-content').slideUp();
//			$('.sort-content').removeClass('open');
		}
		return false;
    });

};
